import { API_URL, GOCARDLESS_SERVICE_PATH } from '@/constants/apiUrl'
import { axiosInstance } from './axiosConfig'
import { forceRedirect, forceReplace, withCommonQueryParams } from './forceRedirect'
import type { GocardlessGetContextResponse } from '@/types/gocardless'

// The in-app screens a GoCardless session may pause on after the bank, before it is handed back to
// onboarding: reached by a full navigation in the same browser, with the `gocardless-session` cookie.
export const INCOME_CONFIRMATION_PATH = '/gocardless-income-confirmation'
export const IBAN_CONFIRMATION_PATH = '/gocardless-iban-confirmation'

const GET_CONTEXT_URL = `${API_URL}/${GOCARDLESS_SERVICE_PATH}/get-context`
const REDIRECT_BACK_URL = `${API_URL}/${GOCARDLESS_SERVICE_PATH}/redirect-back`

/** `GET /gocardless/get-context`: what the screens of the session may show, by the session cookie */
export const getGocardlessContext = async (): Promise<GocardlessGetContextResponse> => {
  const { data } = await axiosInstance.get<GocardlessGetContextResponse>(GET_CONTEXT_URL, {
    withCredentials: true,
  })

  return data
}

// The user's way out of open banking before the bank (only when `get-context` says `isCancellable`):
// the backend fails the GoCardless session as cancelled and sends the browser on to onboarding, which
// rewinds the journey to the step before open banking. A full navigation like `redirect-back`, but
// replacing the GoCardless entry: the session is dead afterwards (its cookie is expired, so the
// screens would only get 401s), so Back from the questionnaire must skip it.
export const cancelGocardless = (): void => {
  forceReplace(`${API_URL}/${GOCARDLESS_SERVICE_PATH}/cancel`)
}

/** hands the session back to onboarding; a full navigation, the backend decides where the user goes */
export const redirectBackFromGocardless = (): void => {
  forceRedirect(REDIRECT_BACK_URL)
}

/** on to the income confirmation screen, same browser, same cookie; language and themeId travel in the URL */
export const goToIncomeConfirmation = (): void => {
  forceRedirect(withCommonQueryParams(INCOME_CONFIRMATION_PATH))
}
